import React from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';  // Dark theme
import 'prismjs/components/prism-python';    // Python language support
import 'prismjs/components/prism-c';         // C/C++ language support for Arduino
import '../styles/CodeDisplay.css';

const CodeDisplay = ({ title, code }) => {
  React.useEffect(() => {
    Prism.highlightAll();
  }, [code]);

  const getDescription = () => {
    if (title === 'V0ID-PORTAL.py') {
      return (
        <>
          <p className="code-description">
            The following is the python script that ran the entire project on a Raspberry Pi. Essentially what it does is play a video that contains a random amalgamation of portals and scenes, and when the video reaches the timestamp where the scene/snapshot begins, the soundscape starts playing from a random time in a loop. The snapshot keeps displaying until the button is pressed again, with which the process begins again.
          </p>
          <p className="code-description">
            I am not entirely sure this is the final version of my code, as I made some last minute changes the day of presentation, but it certainly shows the main ideas. I also used GPT to help write comments as I did not write great comments at the time.
          </p>
        </>
      );
    } else if (title === 'SARCASTIC-BOX.ino') {
      return (
        <p className="code-description">
          The code for this project is pretty simple. It is written in Arduino's modified version of c++, and it essentially sets up our ports and connections, and then makes it so that if the microphone captures sound at a specified decibel level or above, the sound of the "alarm" is played, followed by the sound of the next "warning message" in the infinitely looping queue of 6 warning messages.
        </p>
      );
    } else if (title === 'FLANGEBENDER.ino') {
      return (
        <>
          <p className="code-description">
            This Arduino code controls the FlangeBender prototype using a Teensy 4.1 microcontroller with an audio shield. The code sets up an audio processing graph that applies flange effects to both live audio input and WAV file playback. Two Time-of-Flight (ToF) sensors control the flanger parameters in real-time: sensor #1 controls the rate (frequency) of the flange effect, while sensor #2 controls the depth (intensity). The sensors map hand distance to effect parameters, allowing for intuitive gesture-based control of the audio processing.
          </p>
          <p className="code-description">
            The code for the flanger is largely based on this code, created by GadgetReboot: <a href="https://github.com/GadgetReboot/Arduino/tree/master/Teensy/AudioEffects/SDCardFlangeTest" target="_blank" rel="noopener noreferrer">https://github.com/GadgetReboot/Arduino/tree/master/Teensy/AudioEffects/SDCardFlangeTest</a>
          </p>
        </>
      );
    }
    return null;
  };

  return (
    <div className="code-display-wrapper">
      <h3 className="code-section-title">Source Code</h3>
      {getDescription()}
      <div className="code-display">
        <div className="code-header">
          <span className="code-title">{title}</span>
        </div>
        <pre className="code-content">
          <code className={`language-${title.endsWith('.py') ? 'python' : 'c'}`}>
            {code}
          </code>
        </pre>
      </div>
    </div>
  );
};

export default CodeDisplay; 